import { first } from 'rxjs/operators';
import { GuestProfileService } from '@app/_components/guest-profile';
import { GuestProfile } from '../../guest-profile';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GuestProfileComponent } from '../guest-profile/guest-profile.component';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ConstantService } from '@app/_services';
import { ImportExportComponent } from '@app/_components/_helpers/import-export/import-export.component';

@Component({
    selector: 'app-guest-profile-list',
    templateUrl: './guest-profile-list.component.html',
    styleUrls: ['./guest-profile-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class GuestProfileListComponent implements OnInit {

	sampleLink = 'https://s3.us-east-1.amazonaws.com/img.kbmblog.com/import_owner_profile_sample.xlsx';
	@ViewChild(ImportExportComponent) importExportComponent: ImportExportComponent;

	constructor(
		private guestProfileService: GuestProfileService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		private constantService: ConstantService,
	) {
		this.statuses = guestProfileService.statuses
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	guestProfiles: any;
	guestProfile: GuestProfile;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'firstName', header: 'First Name', width: 'auto' },
		{ field: 'lastName', header: 'Last Name', width: 'auto' },
		{ field: 'emailAddress', header: 'Email Address', width: 'auto' },
		{ field: 'mobilePhone', header: 'Mobile Phone', width: 'auto' },
		{ field: 'reservationVO.shortTermRentalVO.developmentVO.addressDevelopmentName', header: 'Resort Name', width: 'auto' },
		{ field: 'reservationStatus', header: 'Reservation Status', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}
	getFilteredTags(tags) {
		//if filter text input is empty then load all records
		if(tags == '0') {
			delete this.lazyLoadEvent.filters.guestProfileId;
			this.loadLazy(this.lazyLoadEvent);
		} else {
			//If records found then show filtered records
			if(tags.length > 0) {
				//if filter text input is not empty then load filtered records only
				var filteredIds = [];
				tags.forEach(tag => {
					filteredIds.push(tag.tagSourceId);
				});
				let activityProviderIdFilter = { 'guestProfileId': { 'value': filteredIds, 'matchMode': 'in' } };
				Object.assign(this.lazyLoadEvent.filters, activityProviderIdFilter);
				this.loadLazy(this.lazyLoadEvent);
			} else {
				//Display empty table as no record found with filtered input
				this.guestProfiles = [];
			}
		}
	}
	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.guestProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-guestProfile-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.guestProfileService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.guestProfiles = res.data.guestProfiles;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.guestProfiles = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(guestProfile: GuestProfile) {
		try {
			this.formLoading = true;
			this.guestProfileService.update(guestProfile)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.guestProfiles.map((guestProfile, i) => {
							if (guestProfile.guestProfileId === res.data.guestProfile.guestProfileId) {
								this.guestProfiles[i] = res.data.guestProfile;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(guestProfile: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(guestProfile));

			this.formLoading = true;
			this.guestProfileService.delete(guestProfile.guestProfileId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.guestProfiles.splice(this.guestProfiles.indexOf(guestProfile), 1);
						this.recordTotal = this.guestProfiles.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'GuestProfile ' + guestProfile.guestProfileId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'GuestProfile ' + guestProfile.guestProfileId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add GuestProfile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(GuestProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addGuestProfileCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(guestProfile: GuestProfile) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			guestProfile: guestProfile,
			title: 'Edit GuestProfile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(GuestProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateGuestProfileCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteGuestProfileCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addGuestProfileCB(guestProfile: GuestProfile) {
		console.log('Adding GuestProfile: ' + JSON.stringify(guestProfile));
		// if we don't have a guestProfiles array yet...
		if (!this.guestProfiles) {
			this.guestProfiles = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.guestProfiles.unshift(guestProfile);

		// no idea what this is but it is required to update the array
		this.guestProfiles = [...this.guestProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'GuestProfile ' + guestProfile.guestProfileId + ' Added', life: 3000 });
	}

	updateGuestProfileCB(guestProfile: GuestProfile) {
		console.log('Updating GuestProfile: ' + JSON.stringify(guestProfile));
		let itemIndex = this.guestProfiles.findIndex((item: any) => item.guestProfileId === guestProfile.guestProfileId);
		this.guestProfiles[itemIndex] = guestProfile;

		// no idea what this is but it is required to update the array
		this.guestProfiles = [...this.guestProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'GuestProfile ' + guestProfile.guestProfileId + ' Updated', life: 3000 });
	}

	deleteGuestProfileCB(guestProfile: GuestProfile) {
		console.log('Removing GuestProfile: ' + guestProfile);
		this.guestProfiles.splice(this.guestProfiles.indexOf(guestProfile), 1);
		this.recordTotal = this.guestProfiles.length;

		// no idea what this is but it is required to update the array
		this.guestProfiles = [...this.guestProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'GuestProfile ' + guestProfile.guestProfileId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.guestProfiles ? this.first === (this.guestProfiles.length - this.rows) : true; }
	isFirstPage(): boolean { return this.guestProfiles ? this.first === 0 : true; }

	getResStatusName(guestProfile: any) {
		if (guestProfile?.reservationVO?.reservationStatus) {
			const status = this.constantService.reservationStatuses.find((e: any) => e.value == guestProfile?.reservationVO?.reservationStatus);
			return status.label;
		}
		else {
			return '';
		}
	}
	get Statuses() {
		return this.statuses;
	}

	reloadPage() {
		window.location.reload();
	}
	
	showPaginator()
	{
		return true;
	}

	exportSelected(exporttype: any) {
		this.importExportComponent.exporData(exporttype, this.guestProfiles, 'Guest Profiles');
		}
}
